import { Avatar, Box, Typography } from "@mui/material";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export const FlagIcon = ({ countryCode, alt, countryName, size = 24 }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
      <Avatar
        alt={alt}
        src={`${getEnvironmentVariable(
          "SYSTEM_IMAGES_CLOUDFRONT"
        )}/system-images/countries/${countryCode}.svg`}
        sx={{
          width: size * 1.5,
          height: size,
          borderRadius: "3px"
        }}
      />
      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
        {countryName}
      </Typography>
    </Box>
  );
};
